import { useQuery, useMutation } from 'react-query';
import queryGetCustomizations from './query/getCustomizations';
import mutationUpdateLabel from './mutations/updateLabel';
import mutationDeleteCustomization from './mutations/deleteCustomization';
import queryGetCustomization from './query/getCustomization';
import mutationSaveCustomization from './mutations/saveCustomization';
import mutationPublishCustomization from './mutations/publishCustomization';
import mutationUpdateCustomization from './mutations/updateCustomization';

const actionsCustomization = {
    // Getters
    getCustomizations: (params, enabled) => useQuery(queryGetCustomizations(params, enabled)),
    getCustomization: (params, enabled = true) => useQuery(queryGetCustomization(params, enabled)),

    // Mutations
    updateLabel: (onSuccess, onError) => useMutation(mutationUpdateLabel(onSuccess, onError)),
    deleteCustomization: (onSuccess, onError) => useMutation(mutationDeleteCustomization(onSuccess, onError)),
    saveCustomization: (onSuccess, onError) => useMutation(mutationSaveCustomization(onSuccess, onError)),
    updateCustomization: (onSuccess, onError) => useMutation(mutationUpdateCustomization(onSuccess, onError)),
    publishCustomization: (onSuccess, onError) => useMutation(mutationPublishCustomization(onSuccess, onError))

};

export default actionsCustomization;